import { render, staticRenderFns } from "./RestoreContact.vue?vue&type=template&id=0fa1bea6&scoped=true"
import script from "./RestoreContact.vue?vue&type=script&lang=js"
export * from "./RestoreContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa1bea6",
  null
  
)

export default component.exports